import React from "react";
import {useTranslation} from "@unibuddy/intl";
import {View} from "@unibuddy/patron";

import {AuthPageContainer} from "../components/AuthPageContainer";
import {PageTitle} from "../../../../components/PageTitle/PageTitle";
import {RegisterPage2Heading} from "../components/RegisterPage2Heading";
import {RegisterPage2FormHandler} from "../components/RegisterPage2FormHandler";
import {InstitutionPolicyText} from "../components/InstitutionPolicyText";
import {IntlNamespaces} from "../../../../translations/types";
import {INTL_REGISTER_DETAILS} from "../../../../translations/signup";
import {CookieSettings} from "../../../../widgets/shared/components/CookieSettings/CookieSettings";

export function RegisterPage2() {
    const {t} = useTranslation(IntlNamespaces.SIGNUP);

    return (
        <View alignItems="center" gap="small">
            <AuthPageContainer>
                <PageTitle
                    title={t(INTL_REGISTER_DETAILS.key, INTL_REGISTER_DETAILS.defaultValue)}
                />
                <RegisterPage2Heading />
                <View gap="medium-large">
                    <RegisterPage2FormHandler />
                    <InstitutionPolicyText />
                </View>
            </AuthPageContainer>
            <CookieSettings />
        </View>
    );
}
